import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=582d9cbd&scoped=true"
import script from "./PersonalCenter.vue?vue&type=script&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=582d9cbd&prod&scoped=true&lang=less"
import style1 from "./PersonalCenter.vue?vue&type=style&index=1&id=582d9cbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d9cbd",
  null
  
)

export default component.exports